import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Instance Lenis courante (si active) — pour scrollTo programmatique. */
let lenisInstance = null;

export function scrollToTop() {
    if (lenisInstance) {
        lenisInstance.scrollTo(0, { immediate: true });
    }
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
}

export default function SmoothScroll() {
    const { pathname } = useLocation();

    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
    }, []);

    // Remonter en haut à chaque changement de page (Lenis + window)
    useEffect(() => {
        scrollToTop();
        // Après hydratation lazy / layout, re-forcer une fois
        const id = requestAnimationFrame(() => scrollToTop());
        return () => cancelAnimationFrame(id);
    }, [pathname]);

    useEffect(() => {
        const prefersReduced = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;
        if (prefersReduced) return;

        let cancelled = false;
        let rafId;
        let idle;

        const start = () => {
            import("lenis").then(({ default: Lenis }) => {
                if (cancelled) return;
                const lenis = new Lenis({
                    duration: 1.15,
                    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                    smoothWheel: true,
                });
                lenisInstance = lenis;

                function raf(time) {
                    lenis.raf(time);
                    rafId = requestAnimationFrame(raf);
                }
                rafId = requestAnimationFrame(raf);

                // Au cas où on arrive mid-page au boot Lenis
                lenis.scrollTo(0, { immediate: true });
            });
        };

        // Laisse le LCP (portrait) s'afficher avant d'hydrater Lenis
        idle =
            typeof window.requestIdleCallback === "function"
                ? window.requestIdleCallback(start, { timeout: 1800 })
                : setTimeout(start, 900);

        return () => {
            cancelled = true;
            if (typeof window.cancelIdleCallback === "function") {
                window.cancelIdleCallback(idle);
            } else {
                clearTimeout(idle);
            }
            if (rafId) cancelAnimationFrame(rafId);
            if (lenisInstance) {
                lenisInstance.destroy();
                lenisInstance = null;
            }
        };
    }, []);

    return null;
}
